const ORDER_MANAGEMENT_ISSUE_TYPES = [{
  label: 'Order Not Received',
  value: 1,
  key: 1,
  icon: 'BugFilled', // Unexpected issue, item not delivered
  color: '#c62828',
  background: 'rgba(255,171,145,0.16)'
}, {
  label: 'Damaged Product',
  value: 2,
  key: 2,
  icon: 'ImprovementsFilled', // Suggests something broken that needs fixing
  color: '#ef6c00',
  background: 'rgba(255,224,178,0.16)'
}, {
  label: 'Wrong Item Delivered',
  value: 3,
  key: 3,
  icon: 'SubtaskFilled', // Task gone wrong / mismatch
  color: '#f57c00',
  background: 'rgba(255,204,128,0.16)'
}, {
  label: 'Delayed Delivery',
  value: 4,
  key: 4,
  icon: 'StoryFilled', // Timeline impacted
  color: '#6a1b9a',
  background: 'rgba(209,196,233,0.16)'
}, {
  label: 'Refund Not Received',
  value: 5,
  key: 5,
  icon: 'FeatureRequestFilled', // Refund = request not fulfilled
  color: '#2e7d32',
  background: 'rgba(165,214,167,0.16)'
}, {
  label: 'Return Rejected',
  value: 6,
  key: 6,
  icon: 'ChangerequestFilled', // Attempted action denied
  color: '#d84315',
  background: 'rgba(255,204,188,0.16)'
}, {
  label: 'Payment Failed',
  value: 7,
  key: 7,
  icon: 'EpicFilled', // High-impact failure
  color: '#ad1457',
  background: 'rgba(244,143,177,0.16)'
}, {
  label: 'Duplicate Order',
  value: 8,
  key: 8,
  icon: 'TaskFilled', // Repeated unit/task
  color: '#455a64',
  background: 'rgba(176,190,197,0.16)'
}, {
  label: 'Order Cancellation Issue',
  value: 9,
  key: 9,
  icon: 'SupportFilled', // Help/support needed for cancellation
  color: '#0288d1',
  background: 'rgba(144,202,249,0.16)'
}];


export { ORDER_MANAGEMENT_ISSUE_TYPES };
